module.exports = __webpack_public_path__ + "static/media/logo.506ea7ef.png";